export default "/images/infant_feeding_professional_development_sm.jpg?eac32569d99af311b958d27ec3f4efab";